import Nullable from "@/types/utils/Nullable";

export const safeDecode = (value: string): string => {
    try {
        return decodeURIComponent(value);
    } catch {
        return value;
    }
}

export const getCookie = (name: string): string | undefined => {
    const cookies = document.cookie.split(';')
    const cookie = cookies.find(c => c.trim().split('=')[0] === name.trim())
    
    if(cookie){
      return cookie.split('=')[1]
    }
  }
  
export const setCookie = (name: string, value: string, expiration?: Date) => {
    let expires = ''
    
    if(expiration){
      expires = ` expires=${expiration.toUTCString()};`
    }
    
    document.cookie = `${name}=${value};${expires} path=/`
}
  
export const deleteCookie = (name: string) => {
    document.cookie = `${name}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`
}

export default {
    get(c_name: string, default_value: Nullable<string> = null): Nullable<string>{
        let i, x, y, ARRcookies = document.cookie.split(";");
        for (i = 0; i < ARRcookies.length; i++) {
            x = ARRcookies[i].substring(0, ARRcookies[i].indexOf("="));
            y = ARRcookies[i].substring(ARRcookies[i].indexOf("=") + 1);
            x = x.replace(/\s+/g, "");
            if (x === c_name) {
                return safeDecode(y);
            }
        }

        return default_value;
    }
};